import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Insurance() {
  return (
    <LegalPage
      title="Insurance & Safety Disclosure"
      eyebrow="Your safety, our priority"
      intro="Tour Trips India Holidays is fully insured and licensed to operate inbound tourism services. This page outlines our insurance coverage, what we recommend for travelers, and the safety standards we follow."
      seoDesc="Insurance and safety disclosures for tours operated by Tour Trips India Holidays."
      sections={[
        {
          heading: "1. Our liability insurance",
          paragraphs: [
            "Tour Trips India Holidays maintains a comprehensive Public Liability Insurance policy with an authorised Indian general insurer, covering bodily injury and property damage claims arising from our operations.",
            "All transport vehicles used on our tours are covered by full Commercial Passenger Vehicle Insurance per Indian Motor Vehicle Act 1988, including third-party and own-damage cover, plus extended Personal Accident Cover for passengers.",
            "Certificates of insurance can be provided on written request to info@ttiholidays.com — we encourage you to verify before your tour.",
          ],
        },
        {
          heading: "2. Licenses and approvals",
          paragraphs: [
            "Approved Inbound Tour Operator under the Ministry of Tourism, Government of India.",
            "Member, Indian Association of Tour Operators (IATO).",
            "All city guides are licensed by the Ministry of Tourism / state tourism boards; safari guides are licensed by the respective national park authorities.",
            "Drivers hold commercial licenses and complete annual refresher training.",
          ],
        },
        {
          heading: "3. Travel insurance — mandatory for guests",
          paragraphs: [
            "Comprehensive travel insurance is mandatory for every traveler on our tours. Your policy must cover at minimum:",
            "• Emergency medical expenses and hospitalisation (recommended cover: ≥ USD 100,000).",
            "• Emergency medical evacuation and repatriation.",
            "• Trip cancellation and curtailment.",
            "• Baggage loss / delay.",
            "• Personal liability.",
            "• Any adventure activity included in your itinerary (trekking, jeep safari, hot-air balloon, white-water rafting, paragliding, scuba diving).",
            "Proof of insurance may be requested at any point during the tour. Failure to produce valid insurance may result in restriction from certain activities.",
          ],
        },
        {
          heading: "4. Health and vaccination",
          paragraphs: [
            "There are no mandatory vaccinations to enter India unless arriving from a country with yellow-fever risk (in which case yellow-fever certificate is mandatory).",
            "Recommended (consult your physician): Hepatitis A & B, Typhoid, Tetanus, and Polio boosters. Anti-malarial prophylaxis for certain wildlife & rural itineraries (Ranthambore, Sundarbans, Northeast).",
            "Guests with pre-existing medical conditions, mobility limitations, or pregnancy beyond 20 weeks must inform us in writing at the time of booking so we can plan accordingly.",
          ],
        },
        {
          heading: "5. Wildlife & ethical animal welfare",
          paragraphs: [
            "We follow strict ethical wildlife guidelines: no elephant rides, no captive-tiger photo sessions, no encounters with chained or sedated animals.",
            "Where elephant or camel transport features traditionally (e.g., Amber Fort jeep, Pushkar camel safari), we offer jeep alternatives and only use partners we have personally verified.",
          ],
        },
        {
          heading: "6. Emergency response",
          paragraphs: [
            "24/7 ground support: every guest is provided with the WhatsApp number of our duty manager throughout the tour. We aim to respond within 5 minutes during operating hours.",
            "Hospital network: we maintain partnerships with reputed multi-specialty hospitals in Delhi, Agra, Jaipur, Udaipur, Mumbai, Bangalore, Kochi and major safari hubs for fast-track admission of insured guests.",
          ],
        },
      ]}
    />
  );
}
